export const NO_SELECTION = 0;
export const MEDAL = 1;
export const TEAM_CANADA = 2;
export const MEDAL_TEAM_CANADA = 3;

export const SCHEDULE_DATA_CACHED_TIME = 120000; // 2 minutes

export const SCHEDULE_IS_EMPTY_DESCRIPTION =
    "There are no upcoming events scheduled.";

export const QUERY_PARAM_SPORT = "sport";

export const PAGE_DESCRIPTION_TEMPLATE = (tz) => `Times in ${tz} `;
